import * as React from 'react';
import { SVGProps } from 'react';

const SvgIcFavourite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M15.11 4.544a1 1 0 0 1 1.78 0l3.472 6.778 7.778 1.097a1 1 0 0 1 .626 1.634l-.082.085L23.08 19.4l1.322 7.425a1 1 0 0 1-1.336 1.112l-.101-.045-6.965-3.531-6.963 3.531a1 1 0 0 1-1.45-.958l.013-.11L8.92 19.4l-5.604-5.262a1 1 0 0 1 .43-1.696l.114-.023 7.777-1.097 3.473-6.778Zm.89 2.65-2.818 5.503a1 1 0 0 1-.75.534l-6.226.877 4.478 4.205a1 1 0 0 1 .315.78l-.014.124-1.066 5.984 5.629-2.852a1 1 0 0 1 .78-.053l.124.053L22.08 25.2l-1.065-5.984a1 1 0 0 1 .214-.812l.087-.092 4.477-4.205-6.225-.877a1 1 0 0 1-.688-.43l-.062-.104L16 7.194Z"
    />
  </svg>
);
export default SvgIcFavourite;
